import { render, staticRenderFns } from "./login.vue?vue&type=template&id=7dde3898&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=7dde3898&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dde3898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dde3898')) {
      api.createRecord('7dde3898', component.options)
    } else {
      api.reload('7dde3898', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=7dde3898&scoped=true", function () {
      api.rerender('7dde3898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/admin/login.vue"
export default component.exports